var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13246",
    "data-name": "Group 13246",
    transform: "translate(-66 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13244",
    "data-name": "Group 13244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18402",
    "data-name": "Rectangle 18402",
    width: 24,
    height: 24,
    transform: "translate(66 250)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13245",
    "data-name": "Group 13245",
    transform: "translate(-24.594 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    d: "M17.5,31.515c1.866,0,2.885-1.32,2.885-3.179H14.6C14.6,30.2,15.624,31.515,17.5,31.515Z",
    transform: "translate(85.445 247.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    "data-name": "Path 3357",
    d: "M25.707,21.7c-.924-1.218-2.741-1.932-2.741-7.384,0-5.6-2.471-7.846-4.775-8.386-.216-.054-.372-.126-.372-.354V5.406a1.464,1.464,0,1,0-2.927,0V5.58c0,.222-.156.3-.372.354C12.21,6.48,9.745,8.723,9.745,14.32c0,5.453-1.818,6.16-2.741,7.384a1.191,1.191,0,0,0,.954,1.908h16.8A1.191,1.191,0,0,0,25.707,21.7Z",
    transform: "translate(86.239 251.07)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.262219a1248273986876c8ecc61f1f2e.svg";
export { ForwardRef as ReactComponent };